import apiClient from './config';
import { handleApiError } from './utils';
import { RecentAddressOrdersResponse } from '../types/order';

export const getRecentAddressOrders = async (
  addressId: string,
): Promise<RecentAddressOrdersResponse> => {
  try {
    const response = await apiClient.get<RecentAddressOrdersResponse>(
      '/api/orders/address/recent',
      {
        params: { addressId },
      },
    );

    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Stay(숙소) 기준 최근 주문 조회.
 * - stayId 는 숙소의 stay_id(UUID) — 대리키 id 아님 (주문의 origin_stay_id 와 매칭)
 * - hours 미전달 시 백엔드 기본값(3시간) 사용. 전달 시 허용 범위 1~24
 * - 응답 구조는 service-user 최근 주문과 100% 동일
 */
export const getRecentStayOrders = async (
  stayId: string,
  hours?: number,
): Promise<RecentAddressOrdersResponse> => {
  try {
    const response = await apiClient.get<RecentAddressOrdersResponse>(
      `/api/orders/stays/${stayId}/recent`,
      hours != null ? { params: { hours } } : undefined,
    );

    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * serviceUserId 기준 최근 주문 조회 (stay 정보가 없는 세션용 폴백).
 * 응답 구조는 stay 기준 조회와 100% 동일.
 */
export const getRecentServiceUserOrders = async (
  serviceUserId: string,
): Promise<RecentAddressOrdersResponse> => {
  try {
    const response = await apiClient.get<RecentAddressOrdersResponse>(
      `/api/orders/service-users/${serviceUserId}/recent`,
    );

    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * 최근 주문 조회 진입점. stay 기준을 우선하고, stay 정보가 없으면
 * serviceUserId 기준으로 폴백한다. 둘 다 없으면 빈 결과를 반환한다.
 * 우선순위 규칙을 여기 한 곳에 두어 호출부들이 다시 갈라지지 않게 한다.
 */
export const getRecentOrders = (
  { stayId, serviceUserId }: { stayId?: string | null; serviceUserId?: string | null },
): Promise<RecentAddressOrdersResponse> => {
  if (stayId) return getRecentStayOrders(stayId);
  if (serviceUserId) return getRecentServiceUserOrders(serviceUserId);
  return Promise.resolve({ orders: [] });
};

